module.exports = __webpack_public_path__ + "img/klg.bd71eae6.jpg";